
import { defineComponent, PropType, reactive, Ref, ref, watch } from 'vue'
import { cleanObject, compareObjects, debounceRef } from '@/api/tools'
import InputCheck from '@/components/inputs/InputCheck.vue'
import LocationSearch from '@/components/route/LocationSearch.vue'
import { store } from '@/store'
import { Location } from '../../api/models/Location'
import { Place } from '@/api/tripply/models'
import { getPlaceSymbol } from '@/api/tripply'

export default defineComponent({
  name: 'PlaceSettings',
  props: {
    open: Boolean,
    routeId: {
      type: String,
      required: true
    },
    placeIndex: {
      type: Number,
      required: true
    },
    place: {
      type: Object as PropType<Place>,
      required: true
    }
  },
  components: { InputCheck, LocationSearch },
  setup(props, { emit }) {
    const saving = ref(false)
    const showLocationSearch = ref(false)
    const addressChanged = ref(false)
    
    function watchChanges<T extends object>(source: T, target: T) {
      source = cleanObject(source)
      const changes: Ref<Partial<T>> = ref({})
      watch(target, (newTarget) => {
        changes.value = compareObjects<T>(source, cleanObject(newTarget))
      })
      return changes
    }

    const placeEdited = reactive<Place>({ ...props.place })

    const customBreak = ref(placeEdited.breakTime >= 0)
    
    if (placeEdited.breakTime >= 0) placeEdited.breakTime /= 60

    watch(customBreak, (val) => {
      placeEdited.breakTime = val ? 0 : -1
    })

    async function changeLocation(location: Location) {
      // Update name if address is changed
      if (placeEdited.name == placeEdited.address.split(',')[0]) {
        placeEdited.name = location.name
      }
      placeEdited.address = location.address
      placeEdited.coords = location.coords
      addressChanged.value = true
      showLocationSearch.value = false
    }

    async function update() {
      saving.value = true
      const updatedPlace = {...placeEdited}
      if (updatedPlace.breakTime >= 0) updatedPlace.breakTime *= 60   
      await store.route.updatePlace(props.routeId, props.placeIndex, updatedPlace)
      saving.value = false
      store.modal.hideModal('PlaceSettings')
    }

    return { placeEdited, customBreak, saving, update, changeLocation, showLocationSearch, getPlaceSymbol }
  }
})
